<template>
  <div id="app" itemscope itemtype="https://schema.org/WebPage">
    <AppHeader :robotEnabled="robotEnabled" />

    <Breadcrumbs />

    <div class="container-fluid px-2 content">
      <div class="main__row">
        <div class="main__col-app">
          <router-view />
        </div>

        <div v-if="robotEnabled" class="main__col-robot">
          <Robot />
        </div>
      </div>
    </div>

    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import AppFooter from '@common/components/_ui/AppFooter.vue'
import AppHeader from '@common/components/_ui/AppHeader.vue'
import Breadcrumbs from '@common/components/_ui/Breadcrumbs.vue'
import Robot from '@common/components/_ui/Robot.vue'
import { ROBOT } from '@common/config'

const robotEnabled = computed<boolean>(() => ROBOT.enabled)
</script>

<style lang="scss">
@use '@/styles/global.scss';
</style>
